/* import __COLOCATED_TEMPLATE__ from './group.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { A } from '@ember/array';
let FlyCheckboxDropdownGroupComponent = (_class = class FlyCheckboxDropdownGroupComponent extends Component {
  get isIndeterminate() {
    if (this.isChecked) {
      return false;
    }
    let childValues = this.args.group.items.map(item => item.value);
    let {
      selectedItems
    } = this.args;
    return childValues.some(value => selectedItems.includes(value));
  }
  get isChecked() {
    let childValues = this.args.group.items.map(item => item.value);
    let {
      selectedItems
    } = this.args;
    return childValues.every(value => selectedItems.includes(value));
  }
  onChange(_itemName, checked) {
    let childValues = this.args.group.items.map(item => item.value);
    if (checked) {
      this.args.onChange(A([...this.args.selectedItems, ...childValues]).uniq());
    } else {
      this.args.onChange(this.args.selectedItems.filter(selectedItem => !childValues.includes(selectedItem)));
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype)), _class);
export { FlyCheckboxDropdownGroupComponent as default };